import type { ProductGroupCode } from '@/api/inventory';

/**
 * Cikkcsoport-szűrő címke-kulcsok (INV-FG-1-2, QA-29).
 *
 * `Record<ProductGroupCode, …>` — TELJES leképezés: ha a `ProductGroupCode`
 * új taggal bővül és ide nem kerül be, az **fordítási hiba**, nem néma kiesés.
 * A QA-29 pontosan a néma kiesés volt: az enum 11 tagra bővült, a szűrő-tömb
 * 8-on maradt, és egyetlen ellenőrzés sem fogta meg — a felhasználó nem
 * hibaüzenetet kapott, hanem üres találatot.
 *
 * A séma-egyezést az `InventoryListPage.product-group-parity.spec.ts`
 * asserteli a `product.prisma` ELLEN (nem másolat ellen).
 */
export const PRODUCT_GROUP_LABEL_KEYS: Record<ProductGroupCode, string> = {
  ALKATRESZ: 'inventory.productGroups.ALKATRESZ',
  GEP: 'inventory.productGroups.GEP',
  TARTOZEK: 'inventory.productGroups.TARTOZEK',
  SZERSZAM: 'inventory.productGroups.SZERSZAM',
  MUNKARUHA: 'inventory.productGroups.MUNKARUHA',
  VEGYSZER: 'inventory.productGroups.VEGYSZER',
  EGYEB: 'inventory.productGroups.EGYEB',
  BERGEP: 'inventory.productGroups.BERGEP',
  DIJAK: 'inventory.productGroups.DIJAK',
  SZERZODESES: 'inventory.productGroups.SZERZODESES',
  BERENDEZES: 'inventory.productGroups.BERENDEZES',
};

/** A szűrő-legördülő értékei — a fenti teljes leképezésből származtatva. */
export const PRODUCT_GROUP_CODES: { code: ProductGroupCode; labelKey: string }[] = (
  Object.keys(PRODUCT_GROUP_LABEL_KEYS) as ProductGroupCode[]
).map(code => ({ code, labelKey: PRODUCT_GROUP_LABEL_KEYS[code] }));
